export enum PDxUserPermission {
    Purchaser = 1,
    ApproverLevel1 = 2,
    /*			Receiver = 4,
                Payables = 8,
                GLCodes = 16,*/
    ApproverLevel2 = 32,
    ApproverLevel3 = 64,
    ApproverLevel4 = 128,
    ApproverLevel5 = 256,
    Invoicer = 512,
    Dashboard = 1024,
}